{
  "title": "New deposit",
  "description": "Enter the amount and currency, then send the form to the tablet for the depositor to complete and sign.",
  "form": {
    "title": "Deposit details",
    "chooseCurrency": "Choose a currency",
    "decimalsHint": "Up to five decimal places",
    "tabletRequired": "Choose a tablet",
    "voidsSignature": "Changing the amount or currency voids the depositor's signature and sends the form back to the tablet.",
    "customerNotPresent": "Customer not present",
    "customerNotPresentHint": "Nothing is sent to the tablet; the transaction is saved without the customer's data and signature.",
    "saveDraft": "Save the draft"
  },
  "waiting": {
    "summary": "Deposit summary",
    "tabletTitle": "Tablet",
    "onTablet": "The form is on the tablet. Waiting for the depositor.",
    "tabletOffline": "The tablet is offline. Make sure it is on, then resend.",
    "liveReconnecting": "The live connection dropped. Reconnecting...",
    "signatureVoided": "The earlier signature was voided and the form was sent back to the tablet.",
    "resent": "The form was sent to the tablet"
  },
  "review": {
    "language": "Depositor language",
    "languageName": {
      "ar": "Arabic",
      "en": "English"
    },
    "noSignature": "The depositor has not signed",
    "checkCash": "Check the cash and the data before confirming the deposit.",
    "customerNotPresent": "The deposit is saved without the depositor's data and signature."
  },
  "confirm": {
    "statement": "Confirm the cash was received from the depositor"
  },
  "result": {
    "title": "The deposit was created successfully",
    "description": "Print the receipt and hand it to the depositor.",
    "messages": "WhatsApp messages",
    "noMessages": "No messages for this deposit",
    "role": {
      "DEPOSITOR": "Depositor",
      "INTENDED_RECIPIENT": "Intended recipient",
      "ACTUAL_RECIPIENT": "Actual recipient"
    }
  },
  "discard": {
    "action": "Delete draft",
    "title": "Delete the draft?",
    "description": "The unconfirmed deposit data is deleted and the tablet returns to its home screen.",
    "done": "The draft was deleted successfully"
  }
}
